import styled from "styled-components";
import Button from "../../../bootstrap/Button";
import NavItem from "../../../bootstrap/NavItem";

export const BusSeatWrapper = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  text-align: left;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  padding: 16px;
  border-radius: 8px;
  background: #fff;

  @media (max-width: 576px) {
    padding: 12px;
  }

  @media (max-width: 320px) {
    padding: 8px;
  }
`;

export const SeatNo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
  padding: 12px 0;
  border-bottom: 1px solid #d1d1d1;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 500;
  overflow-wrap: anywhere;

  > div {
    width: 100%;
  }
`;

export const FareDetails = styled.div`
  font-size: 14px;
  padding: 12px 0 0;
`;

export const FareHeader = styled.div`
  text-transform: capitalize;
  padding: 6px 0;
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 500;
  color: #172839;
`;

export const PriceItem = styled(NavItem)`
  text-transform: capitalize;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 5px 0;
  font-size: 13px;
  line-height: 1.4;

  > * {
    min-width: 0;
    overflow-wrap: anywhere;
  }
`;

export const LuggageItem = styled(NavItem)`
  text-transform: capitalize;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 5px 0;
  font-size: 13px;
  line-height: 1.4;

  > * {
    min-width: 0;
    overflow-wrap: anywhere;
  }
`;

export const Amount = styled.div`
  font-weight: 600;
  padding-top: 8px;
  text-transform: capitalize;
  font-size: 14px;
  line-height: 1.4;
`;

export const LuggageDetailsWrapper = styled.div`
  border-top: 1px solid #d1d1d1;
  padding-top: 8px;
  margin-top: 8px;
`;

export const TaxText = styled.div`
  padding-bottom: 12px;
  font-size: 12px;
  line-height: 1.5;
  color: #666;
`;

export const BookingBtn = styled(Button)`
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin-top: 12px;
  padding: 10px 14px;
  border: none;
  border-radius: 4px;
  text-transform: capitalize;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
  transition: background-color 0.25s ease, opacity 0.25s ease;

  background: ${(props) => props.btnbgcolor || "#ffcc00"};
  color: ${(props) => props.btntextcolor || "#ffffff"};

  &:hover {
    background: ${(props) =>
      props.btnbghvcolor || props.btnbgcolor || "#e6b800"};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }

  @media (max-width: 576px) {
    padding: 10px;
    font-size: 12px;
  }
`;